import React from 'react';

function HospitalCard({ hospital }) {

  const imagePath = `/images/${hospital.image}`;

  return (
    <div className="container my-4">
      <div className="row align-items-center bg-white shadow rounded p-3">
        
        {/* Hospital Image */}
        <div className="col-12 col-md-2 text-center">
          <img 
            src={imagePath} 
            alt={hospital.name} 
            className="img-fluid rounded-circle hospital-img" 
            style={{ width: '140px', height: '140px', objectFit: 'cover' }} 
          />
        </div>
        
        {/* Hospital Info */}
        <div className="col-12 col-md-4 text-center text-md-start">
          <h5 className="fw-bold">{hospital.name}</h5>
          <p>{hospital.address}</p>
          <a href={`tel:${hospital.phone}`} className="btn btn-primary w-100">
            <i className="fas fa-phone"></i> Call Now
          </a>
        </div>
        
        {/* Map */}
        <div className="col-12 col-md-4">
          <iframe 
            src={hospital.mapUrl}
            width="100%" 
            height="150" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            title={`${hospital.name} Map`}
          ></iframe>
        </div>
        
        {/* Social Links */}
        <div className="col-12 col-md-2 text-center text-md-start socials">
          <p><a style={{ textDecoration: 'none' }} href="#"><i className="bi bi-twitter"></i> Twitter</a></p>
          <p><a style={{ textDecoration: 'none' }} href="#"><i className="bi bi-facebook"></i> Facebook</a></p>
          <p><a style={{ textDecoration: 'none' }} href="#"><i className="bi bi-instagram"></i> Instagram</a></p>
          <p><a style={{ textDecoration: 'none' }} href="#"><i className="bi bi-youtube"></i> YouTube</a></p>
          <p><a style={{ textDecoration: 'none' }} href="#"><i className="bi bi-linkedin"></i> LinkedIn</a></p>
          <p><a style={{ textDecoration: 'none' }} href="#"><i className="bi bi-tiktok"></i> TikTok</a></p>
        </div>
        
      </div>
    </div>
  );
}

export default HospitalCard;